import { useQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

export enum EnterpriseSubscriptionStatus {
  TRIALING = 'trialing',
  ACTIVE = 'active',
  EXPIRED = 'expired',
  IN_GRACE_PERIOD = 'in_grace_period',
  IN_BILLING_RETRY = 'in_billing_retry',
  PAUSED = 'paused',
  UNKNOWN = 'unknown',
  INCOMPLETE = 'incomplete',
}

export interface GetEnterpriseRequest {
  enterpriseId: number
}

export interface LeadSource {
  sourceName: string
  sourceTransactionType: string | null
}

export interface EnterpriseDetailResponse {
  id: number
  enterpriseUrl: string | null
  name: string
  billingEmail: string | null
  subscriptionId: string | null
  totalSeats: number
  totalSpendingLimit: number
  subscriptionStatus: EnterpriseSubscriptionStatus
  position: string
  companySize: string
  companyType: string
  nmlsCompanyIdentifier: string | null
  primaryFocus: string[] | null
  logoPicture: string | null
  iconPicture: string | null
  leadSources: LeadSource[] | null
  generalFirstConversationWorkflowEnabled: boolean
  purchaseIntroductionWorkflowEnabled: boolean
  purchaseSmartHomeSearchWorkflowEnabled: boolean
  purchasePreQualifyWorkflowEnabled: boolean
  refinanceIntroductionWorkflowEnabled: boolean
  refinancePreQualifyWorkflowEnabled: boolean
  deletedAt: string | null
  totalMembers: number | null
  billableSeats: number | null
  prePurchasedSeats: number | null
  activeAndPurchasedMembershipsCount: number | null
}

const getEnterprise = async ({ enterpriseId }: GetEnterpriseRequest) => {
  const response = await getRequest<EnterpriseDetailResponse>(`/enterprise/${enterpriseId}`)
  return response
}

export default function useGetEnterprise({ enterpriseId }: GetEnterpriseRequest) {
  return useQuery({
    ...queries.enterprise.detail(enterpriseId),
    queryFn: () => getEnterprise({ enterpriseId }),
    enabled: enterpriseId > -1,
  })
}
